import apiDocuments from '@/api/documents'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  data: null,
}

export const mutationTypes = {
  deleteDocumentStart: '[delete document] delete document start',
  deleteDocumentSuccess: '[delete document] delete document success',
  deleteDocumentFailure: '[delete document] delete document failure',
}

export const actionTypes = {
  deleteDocument: '[delete document] delete document',
}

const mutations = {
  [mutationTypes.deleteDocumentStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteDocumentSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteDocumentFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.deleteDocument](context, {athleteId, id}) {
    context.commit(mutationTypes.deleteDocumentStart)
    return new Promise((resolve) => {
      apiDocuments
        .deleteAthleteDocument(athleteId, id)
        .then((response) => {
          context.commit(mutationTypes.deleteDocumentSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.deleteDocumentFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
